/**
 * NOTE: This module is used in student header.
 */

import * as React from 'react';

import DownChevronSmall from 'DownChevronSmall';
import HandRaisedIcon from 'HandRaisedIcon';
import StudentHeaderMenu from 'StudentHeaderMenu';

export default class HeaderUserName extends React.Component {
  render() {
    let c = this.props.controller;

    let menuChildren = [
      <div
        key="1"
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <div
          style={{
            color: '#5C6975',
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: '600',
          }}
        >
          {this.props.userName}
        </div>
        <DownChevronSmall
          key="2"
          className="username-chevron"
          color="#5C6975"
        />
      </div>,
      <StudentHeaderMenu key="4" {...this.props} />,
    ];

    if (this.props.handraiseStatus && this.props.handraise) {
      menuChildren.push(
        <span key="5" className="hand-raised">
          <HandRaisedIcon className="hands-raised-icon" />
        </span>
      );
    }

    let containerChildren = [];

    containerChildren.push(
      <div key="7" id="header-user-name" onClick={c.usernameClicked}>
        {menuChildren}
      </div>
    );

    return <div id="header-user-name-container">{containerChildren}</div>;
  }
}
